import './AddToTaskSelector.scss';
import { caseInsensitiveContainsFilterOption } from '@lib/filter';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { Select } from 'antd';
import React, { useMemo } from 'react';
import { useCurrentUser, useInitiativeTasks, useLinkInitiativeTask } from '@hooks';
export const AddToTaskSelector = ({ initiativeId, nameFilter, onSelect, selectAllEnabled, scopeIds, sonarObjectIds, typesFilter }) => {
    const { isReadOnly } = useCurrentUser();
    const { tasks } = useInitiativeTasks(initiativeId);
    const { request } = useLinkInitiativeTask();
    const selectOptions = useMemo(() => {
        var _a;
        return (_a = tasks === null || tasks === void 0 ? void 0 : tasks.map((task) => ({
            label: task.name,
            value: String(task.initiativeTaskId)
        }))) !== null && _a !== void 0 ? _a : [];
    }, [tasks]);
    const handleOnSelect = (value) => {
        const taskId = Number(value);
        request({
            all: selectAllEnabled,
            initiativeId,
            initiativeScopeIds: selectAllEnabled ? [] : scopeIds,
            initiativeScopeIdsToExclude: selectAllEnabled ? scopeIds : [],
            initiativeTaskId: taskId,
            objectNameSearchText: nameFilter,
            objectTypes: typesFilter,
            sonarObjectIds: sonarObjectIds
        });
        onSelect();
    };
    return (React.createElement(Select, { className: 'add-to-task-selector', defaultValue: COPY_SPECIFIC.ADD_TO_TASK, disabled: isReadOnly, filterOption: caseInsensitiveContainsFilterOption, onSelect: handleOnSelect, options: selectOptions, showSearch: true, value: COPY_SPECIFIC.ADD_TO_TASK }));
};
